










































import {Component, Emit, Prop, Watch} from "vue-property-decorator";
import AsiDialogForm from "../common/AsiDialogForm.vue";
import AsiDialogFormLayout from "../common/AsiDialogFormLayout.vue";
import {AxiosError} from "axios";
import AsiTextField from "@/components/common/AsiTextField";
import CompanyAutocompleteInput from "@/components/company/CompanyAutocompleteInput.vue";
import AsiDatePicker from "@/components/common/AsiDatePicker.vue";
import UserUpdate from "@/models/user/UserUpdate";
import User from "@/models/user/User";
import {enumToSelectItems, toISODateString} from "@/helpers/functions_asi";
import {EmploymentType, Gender} from "@/helpers/constants";
import AsiRadioGroup from "@/components/common/AsiRadioGroup";
import AsiAutocomplete from "@/components/common/AsiAutocomplete";
import AsiCountryAutocompleteInput from "@/components/common/AsiCountryAutocompleteInput.vue";

@Component({
	components: {
		AsiCountryAutocompleteInput,
		AsiAutocomplete,
		AsiRadioGroup,
		AsiDatePicker,
		CompanyAutocompleteInput,
		AsiTextField,
		AsiDialogFormLayout
	}
})
export default class UserUpdateDialogBasicData extends AsiDialogForm {

	@Prop({type: Object, required: true})
	public user!: User;

	private model: UserUpdate | null = null;
	private genderOptions = enumToSelectItems(Gender, true);
	private employmentTypeOptions = enumToSelectItems(EmploymentType, true);

	public created(): void {
		this.setUserInternal();
	}

	@Emit('save')
	public save(event: Event): Event {
		return event;
	}

	@Emit('cancel')
	public cancel(event: Event): Event {
		this.setUserInternal();
		const form = this.$refs.form as HTMLFormElement;
		this.reset([], form);
		return event;
	}

	@Watch('user', {deep: true})
	private onUserChanged(): void {
		this.setUserInternal();
	}

	private setUserInternal(): void {
		if (this.model === null) {
			this.model = new UserUpdate(this.user);
		} else {
			this.model.setDetailModel(this.user);
		}
	}

	private requestSave(event: Event): void {
		if (this.model === null) return;

		this.loading = true;
		this.$userService.update(this.user.id, this.model)
			.then(() => this.save(event))
			.catch((err: AxiosError) => {
				this.errors = err.response?.data;
			})
			.finally(() => {
				this.loading = false;
			});
	}

	private get maxBirthdayDate(): string {
		return toISODateString(new Date());
	}

}
